import React from 'react'
import { ActivityIndicator, Platform } from 'react-native'

import { Stack } from '@zet/design-system'
import { IScreenLoader } from '@zet/utils/interface'
import Lottie from 'lottie-react'
import LottieView from 'lottie-react-native'

const ScreenLoader = ({
  isRecommendationFlow,
  showLottie,
  isJFSFlow,
}: IScreenLoader) => {
  const shouldShowLottie = isRecommendationFlow || showLottie
  const height = isJFSFlow ? 70 : 260
  const source = isJFSFlow
    ? require('../../assets/lottie/jfsLoader.json')
    : require('../../assets/lottie/recommendationLoader.json')

  if (shouldShowLottie) {
    return (
      <Stack className="flex-1 justify-center bg-white">
        {Platform.OS === 'web' ? (
          <Lottie
            autoPlay
            loop
            style={{ height, alignSelf: 'center' }}
            animationData={source}
          />
        ) : (
          <LottieView
            autoPlay
            loop
            speed={1}
            style={{ height, width: '100%', alignSelf: 'center' }}
            source={source}
          />
        )}
      </Stack>
    )
  }

  return (
    <Stack className="flex-1 items-center justify-center">
      <ActivityIndicator size="large" />
    </Stack>
  )
}

export default React.memo(ScreenLoader)
